// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__72zGh","detailsBorder":"styles_detailsBorder__2P_rG"};